// extracted by mini-css-extract-plugin
export var gif = "_mk-0";